import { render, staticRenderFns } from "./ModalDutiesAndTaxesView.vue?vue&type=template&id=4e16be1b&scoped=true&"
import script from "./ModalDutiesAndTaxesView.vue?vue&type=script&lang=js&"
export * from "./ModalDutiesAndTaxesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e16be1b",
  null
  
)

export default component.exports